module.exports = __webpack_public_path__ + "static/media/Freemason_s Hall, Plaque.4251bbf0.jpg";